const UK_COMPANY_TYPE_OPTIONS = [
    "Private limited company (Ltd)",
    "Public limited company (PLC)",
    "Private limited by guarantee without share capital",
    "Private unlimited company",
    "Limited liability partnership (LLP)",
    "Limited partnership (LP)",
    "Scottish qualifying partnership (SQP)",
    "General partnership (not Companies House registered)",
    "Sole Trader",
    "Charitable incorporated organisation (CIO) / Registered charity",
    "Unincorporated association (not Companies House registered)",
    "Royal charter company",
    "Overseas company",
    "Overseas entity",
    "UK establishment company",
];

export default UK_COMPANY_TYPE_OPTIONS;
